/* =============================================================================
   Quick Add to Cart
   assets/quick-add.js
   ============================================================================= */

(function () {
  'use strict';

  document.addEventListener('submit', async (e) => {
    const form = e.target;
    const btn = form.querySelector('.product-card__atc');
    if (!btn) return;

    const variantId = btn.dataset.productId;
    if (!variantId) return;

    e.preventDefault();

    btn.classList.add('is-loading');
    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = '...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!res.ok) {
        btn.disabled = false;
        btn.textContent = originalText;
        return;
      }

      btn.textContent = 'Added!';
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');

      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      if (window.renderCartDrawer) window.renderCartDrawer(cart);

      setTimeout(() => {
        btn.textContent = originalText;
        btn.classList.remove('is-added');
        btn.disabled = false;
      }, 1500);

    } catch (err) {
      btn.disabled = false;
      btn.textContent = originalText;
    }
  });

})();
